module.exports = __webpack_public_path__ + "img/image_3.de9b6213.jpg";